<div class="two-column-page-layout-left" [ngClass]="{ sticky: stickyLeft() }">
	<ng-content select="[two-column-page-layout-left-content]"></ng-content>
</div>

<div class="two-column-page-layout-right">
	<ng-content select="[two-column-page-layout-right-content]"></ng-content>
</div>
